module.exports = __webpack_public_path__ + "img/fantasy_1.c586d326.png";